import React from 'react';
import { bemClasses } from '../../helpers';
import { BindingFieldComponent } from './BindingField';
var className = "binding";
export var BindingComponent = function (_a) {
    var name = _a.name, binding = _a.binding;
    if (!binding) {
        return null;
    }
    return (React.createElement("section", null,
        React.createElement("div", null,
            React.createElement("div", { className: "flex py-2" },
                React.createElement("div", { className: bemClasses.concatenate([
                        bemClasses.element(className + "-protocol"),
                        bemClasses.element("badge"),
                    ]) }, name))),
        Object.entries(binding).map(function (_a) {
            var key = _a[0], value = _a[1];
            return (React.createElement(BindingFieldComponent, { value: value, context: key, bindingType: name, key: key }));
        })));
};
//# sourceMappingURL=Binding.js.map